import React from 'react'
import { Button, Tooltip } from '@mui/material';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';

const ImportarArchivo = (props) => {

  const {setRectangulos, clearWorkSpace, setLineas, setElipses, setTextos, setImagenes, setNodos} = props;
  const handleChange = (e) => {
    const fileReader = new FileReader();
    clearWorkSpace();
    fileReader.readAsText(e.target.files[0], "UTF-8");

    fileReader.onload = (e) => {
      const jsonFile = JSON.parse(e.target.result);
      /* console.log(jsonFile[0]);; */
      setLineas(jsonFile[0])
      setNodos(jsonFile[1])
    };
  };

  return (
    <> 
      <Tooltip title="Importar JSON" >
        {/* Cambiar variant para volver a activar funcionalidad */}
        <Button variant="disabled" component="label">
          <UploadFileRoundedIcon/>
          <input 
              hidden
              multiple 
              type="file"
              onChange={handleChange}
            />
        </Button> 
      </Tooltip>
    </>    
  )
}

export default ImportarArchivo;